const KEYS = {
	DOWN: 'ArrowDown',
	UP: 'ArrowUp',
	HOME: 'Home',
	END: 'End',
};

const setAccordionState = (accordion, trigger, content, isOpen) => {
	accordion.classList.toggle('is-open', isOpen);
	content.classList.toggle('hidden', !isOpen);
	content.hidden = !isOpen;
	trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

const setupAccordion = accordion => {
	const trigger = accordion.querySelector('.js-accordion-trigger');
	const content = accordion.querySelector('.js-accordion-content');

	if (!trigger || !content) {
		return;
	}

	if (!trigger.id) {
		trigger.id = `accordion-trigger-${crypto.randomUUID()}`;
	}

	if (!content.id) {
		content.id = `${trigger.id}-panel`;
	}

	if (!trigger.hasAttribute('aria-controls')) {
		trigger.setAttribute('aria-controls', content.id);
	}

	if (!content.hasAttribute('aria-labelledby')) {
		content.setAttribute('aria-labelledby', trigger.id);
	}

	if (!content.hasAttribute('role')) {
		content.setAttribute('role', 'region');
	}

	setAccordionState(accordion, trigger, content, accordion.classList.contains('is-open'));

	trigger.addEventListener('click', () => {
		const isOpen = trigger.getAttribute('aria-expanded') !== 'true';
		setAccordionState(accordion, trigger, content, isOpen);
	});
};

const setupAccordionGroup = group => {
	const triggers = [...group.querySelectorAll('.js-accordion-trigger')];

	if (triggers.length < 2) {
		return;
	}

	triggers.forEach((trigger, index) => {
		trigger.addEventListener('keydown', event => {
			let nextIndex = null;

			if (event.key === KEYS.DOWN) {
				nextIndex = (index + 1) % triggers.length;
			} else if (event.key === KEYS.UP) {
				nextIndex = (index - 1 + triggers.length) % triggers.length;
			} else if (event.key === KEYS.HOME) {
				nextIndex = 0;
			} else if (event.key === KEYS.END) {
				nextIndex = triggers.length - 1;
			}

			if (nextIndex === null) {
				return;
			}

			event.preventDefault();
			triggers[nextIndex].focus();
		});
	});
};

const accordions = document.querySelectorAll('.js-accordion');

if (accordions.length) {
	accordions.forEach(setupAccordion);

	const grouped = new Set();

	accordions.forEach(accordion => {
		const group = accordion.parentElement;

		if (!group || grouped.has(group)) {
			return;
		}

		grouped.add(group);
		setupAccordionGroup(group);
	});
}
